import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import checkUndefinedNullOrEmpty from '../../utils/tools/checkUndefinedNullOrEmpty';
import getStyleQuery from '../../utils/tools/getStyleQuery';
import type { CarPriceGridProps } from './types';

export default function CarPriceGridSkeleton(props: Pick<CarPriceGridProps, 'mini' | 'showMonthlyRate' | 'smaller'>) {
    const { mini, showMonthlyRate, smaller } = props;

    const price = (
        <Stack alignItems="center" justifyContent="center" textAlign="center" sx={{ [getStyleQuery()]: { flexGrow: 1, width: 1 } }}>
            <Skeleton variant="text" sx={{ [getStyleQuery()]: { width: 0.5, typography: smaller ? 'h6' : 'h5' } }} />
            <Skeleton variant="text" sx={{ [getStyleQuery()]: { width: 0.75, typography: 'caption' } }} />
        </Stack>
    );

    const rate = (
        <Stack alignItems="center" justifyContent="center" sx={{ [getStyleQuery()]: { flexGrow: 1, width: 1 } }}>
            <Skeleton variant="text" sx={{ [getStyleQuery()]: { width: 0.75, typography: smaller ? 'h6' : 'h5' } }} />
            <Stack direction="row" alignItems="center" justifyContent="center" gap={1} sx={{ width: 1 }}>
                <Skeleton variant="text" sx={{ [getStyleQuery()]: { width: 0.75, typography: 'caption' } }} />
                {!mini && <Skeleton sx={{ [getStyleQuery()]: { height: (theme) => theme?.rawTypography?.body1?.fontSize, width: (theme) => theme?.rawTypography?.body1?.fontSize, flexShrink: 0 } }} />}
            </Stack>
        </Stack>
    );

    return (
        <Stack gap={1} direction={!mini ? 'row' : 'column'} divider={<Divider orientation={!mini ? 'vertical' : 'horizontal'} flexItem sx={{ borderStyle: 'dashed' }} />}>
            {!checkUndefinedNullOrEmpty(showMonthlyRate) ? rate : price}
            {!mini && checkUndefinedNullOrEmpty(showMonthlyRate) && rate}
        </Stack>
    );
}
